"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moreButton = _interopRequireDefault(require("./more-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PropertiesRibbon =
/*#__PURE__*/
function (_Component) {
  _inherits(PropertiesRibbon, _Component);

  function PropertiesRibbon(props) {
    _classCallCheck(this, PropertiesRibbon);

    return _possibleConstructorReturn(this, _getPrototypeOf(PropertiesRibbon).call(this, props));
  }

  _createClass(PropertiesRibbon, [{
    key: "render",
    value: function render() {
      var data = this.props.content;
      return _react.default.createElement("div", {
        className: "section-header"
      }, _react.default.createElement("div", {
        className: "section-header-actions-narrow-width"
      }, _react.default.createElement(_moreButton.default, {
        size: "regular",
        isPrimary: true,
        title: "ACTIONS"
      }, _react.default.createElement("ul", null, data.actions.map(function (action, index) {
        return _react.default.createElement("li", {
          key: index
        }, _react.default.createElement("a", {
          className: "section-header-link-text",
          onClick: function onClick() {
            return action.action();
          }
        }, action.label));
      }))), _react.default.createElement("br", null), _react.default.createElement("br", null)), _react.default.createElement("div", {
        className: "grid-wrapper section-header-row"
      }, data.labels.map(function (label, index) {
        return index < 5 ? _react.default.createElement("div", {
          className: "col-20"
        }, _react.default.createElement("label", {
          className: "section-header-label"
        }, label.label), _react.default.createElement("br", null), _react.default.createElement("label", {
          className: "section-header-value"
        }, label.value)) : "";
      }), _react.default.createElement("div", {
        className: "col-20 section-header-actions-full-width"
      }, _react.default.createElement(_moreButton.default, {
        size: "regular",
        isPrimary: true,
        title: "ACTIONS"
      }, _react.default.createElement("ul", null, data.actions.map(function (action, index) {
        return _react.default.createElement("li", {
          key: index
        }, _react.default.createElement("a", {
          className: "section-header-link-text",
          onClick: function onClick() {
            return action.action();
          }
        }, action.label));
      }))))), data.labels.length > 5 ? _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "section-header-devider"
      }, _react.default.createElement("br", null)), _react.default.createElement("div", {
        className: "grid-wrapper section-header-row"
      }, data.labels.map(function (label, index) {
        return index > 4 && index < 10 ? _react.default.createElement("div", {
          className: "col-20"
        }, _react.default.createElement("label", {
          className: "section-header-label"
        }, label.label), _react.default.createElement("br", null), _react.default.createElement("label", {
          className: "section-header-value"
        }, label.value)) : "";
      }))) : "");
    }
  }]);

  return PropertiesRibbon;
}(_react.Component);

var _default = PropertiesRibbon;
exports.default = _default;